import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { certificateList } from "../data/DataCertificate.jsx";
import "../styles/Certificate.css";
import ScrollToTop from "../components/ScrollToTop.jsx";
import { useNavigate } from "react-router-dom";

const CertificatePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const expiryTimeCertificate = parseInt(localStorage.getItem("expiryTimeCertificate"), 10);

    if (!isLoggedIn) {
      if (!expiryTimeCertificate || Date.now() > expiryTimeCertificate) {
        // Hapus token dan waktu kedaluwarsa jika tidak valid
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("expiryTimeCertificate");
        navigate("/"); // Redirect ke login
        return;
      }
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  const navRef = useRef(null);

  useEffect(() => {
    if (!navRef.current) {
      console.error("Element with ID 'mainNav' not found!");
      return;
    }

    let scrollPos = 0;
    const headerHeight = navRef.current.clientHeight;

    const handleScroll = () => {
      const currentTop = document.body.getBoundingClientRect().top * -1;
      if (currentTop < scrollPos) {
        if (currentTop > 0 && navRef.current.classList.contains("is-fixed")) {
          navRef.current.classList.add("is-visible");
        } else {
          navRef.current.classList.remove("is-visible", "is-fixed");
        }
      } else {
        navRef.current.classList.remove("is-visible");
        if (currentTop > headerHeight && !navRef.current.classList.contains("is-fixed")) {
          navRef.current.classList.add("is-fixed");
        }
      }
      scrollPos = currentTop;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav ref={navRef} className="navbar navbar-expand-lg navbar-light" id="mainNav">
        <div className="container px-4 px-lg-5">
          <Link to={`/home`} className="navbar-brand text-uppercase">
            Certificate - STII
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            Menu
            <i className="fas fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ms-auto py-4 py-lg-0">
              <li className="nav-item">
                <Link to={`/home`} className="nav-link px-lg-3 py-3 py-lg-4">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to={`/certificate`} className="nav-link px-lg-3 py-3 py-lg-4" href="about.html">
                  Certificate
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link px-lg-3 py-3 py-lg-4">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-lg-3 py-3 py-lg-4">Contact</a>
              </li>
              <li className="nav-item">
                <a className="nav-link px-lg-3  py-3 py-lg-4">
                  <button className="btn btn-sm btn-secondary rounded" onClick={handleLogout}>
                    Log Out
                  </button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <header className="masthead" style={{ backgroundImage: "url('/assets/img/lok-bg.jpg')", height: "50vh" }}>
        <div className="container position-relative px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <div className="site-heading">
                <h1>Certificate</h1>
                <span className="subheading">PT Sumatera Timber Indo Industry</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="container px-4 px-lg-5">
        <div className="row gx-4 gx-lg-5 justify-content-center" style={{ backgroundColor: "#d1dfdf" }}>
          <div className="col-10" style={{ backgroundColor: "#d1dfdf" }}>
            <div className="grid my-4">
              {certificateList.map((item) => {
                return (
                  <div className="item" key={item.id}>
                    <Link to={`/certificate/${item.id}`}>
                      <img src={item.image} />
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <footer className="border-top">
        <div className="container px-4 px-lg-5">
          <div className="row gx-4 gx-lg-5 justify-content-center">
            <div className="col-md-10 col-lg-8 col-xl-7">
              <ul className="list-inline text-center">
                <li className="list-inline-item">
                  <a href="tel:+6261-453-2288" target="__blank">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i class="fa-solid fa-phone fa-stack-1x fa-inverse"></i>
                    </span>
                    {/* (+62 61) 453 2288 */}
                  </a>
                </li>
                {/* <li className="list-inline-item">|</li> */}
                <li className="list-inline-item">
                  <a href="https://www.facebook.com/wiradoor.id/" target="__blank">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-facebook-f fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.instagram.com/wiradoor.id/" target="__blank">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i class="fab fa-instagram fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://www.youtube.com/@ptsumateratimberindoindu-zk4es" target="__blank">
                    <span className="fa-stack fa-lg">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-youtube fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </li>
              </ul>
              <div className="small text-center text-muted fst-italic">Copyright &copy; PT Sumatera Timber Indo Industry {new Date().getFullYear()}</div>
              <div className="small text-center text-muted fst-italic">Powered by Rudi Hadi Syahfitrah</div>
            </div>
          </div>
        </div>
      </footer>
      <ScrollToTop />
    </>
  );
};

export default CertificatePage;
